import { render } from "./EditForm.vue?vue&type=template&id=c74dfc8e"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Form/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__